export const SESSION_EVENTS = {
    SESSION_CREATED: 'sessionCreated',
    CHECKOUT_SUCCESSFUL: 'checkoutSuccessful',
    CHECKOUT_SUCCESSFUL_SHOWN: 'checkoutSuccessfulWasShown',
} as const;

export type SessionEvents = {
    [SESSION_EVENTS.SESSION_CREATED]: { sessionId: string },
    [SESSION_EVENTS.CHECKOUT_SUCCESSFUL]: {token: string},
    [SESSION_EVENTS.CHECKOUT_SUCCESSFUL_SHOWN]: {widgetId?: string}

}